<button [class]="colorClass()" [class]="shapeClass()" [class]="disableButton()" type="button">
    <fa-icon [icon]="icon"></fa-icon>
    <span>{{text}}</span>
</button>